import { render, staticRenderFns } from "./ConfirmationForTable.vue?vue&type=template&id=f3bdeacc&scoped=true&"
import script from "./ConfirmationForTable.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationForTable.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationForTable.vue?vue&type=style&index=0&id=f3bdeacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bdeacc",
  null
  
)

export default component.exports